"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var csrf = require("../csrfUtils");
var DEFAULT_STATE = {
    total: 0,
    term: '',
    options: { exact: false },
    scenes: [],
    fetching: false,
};
exports.buildQuery = function (term, options) {
    if (options.lat && options.lon) {
        options.near = {
            lat: Number(options.lat),
            lon: Number(options.lon),
            distanceKm: options.radius ? Number(options.radius) : undefined,
        };
        delete options.lat;
        delete options.lon;
        delete options.radius;
    }
    if (options.pageSize) {
        options.pageSize = Number(options.pageSize);
    }
    return {
        term: term,
        options: options,
    };
};
exports.getSearch = function (query, isNewSearch, location) {
    return function (dispatch, state) {
        if (isNewSearch && query.term) {
            dispatch(exports.newSearch(query.term, query.options, location));
        }
        dispatch(exports.getMore());
        // TODO: does this look stupid? It's to get around node requiring fetch to have a full url
        return fetch(process.env.serverHost + '/search', {
            method: 'POST',
            headers: csrf.withCSRFToken(),
            body: JSON.stringify(query),
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            dispatch(exports.updateSearchResults(res));
        })
            .catch(function (e) {
            dispatch(exports.updateSearchResults({
                total: state.total,
                hits: [],
            }));
        });
    };
};
exports.updateSearchResults = function (results) {
    return {
        type: 'UPDATE_RESULTS',
        total: results.total,
        scenes: results.hits,
    };
};
exports.clearSearch = function () {
    return {
        type: 'CLEAR_SEARCH',
    };
};
exports.newSearch = function (term, options, location) {
    return {
        type: 'NEW_SEARCH',
        term: term,
        options: options,
        location: location,
    };
};
exports.getMore = function () {
    return {
        type: 'GET_MORE',
    };
};
exports.searchStore = function (state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    switch (action.type) {
        case 'UPDATE_RESULTS':
            return __assign(__assign({}, state), { total: action.total, scenes: __spreadArrays((state.scenes || []), (action.scenes || [])), fetching: false });
        case 'GET_MORE':
            return __assign(__assign({}, state), { fetching: true });
        case 'CLEAR_SEARCH':
            return __assign({}, DEFAULT_STATE);
        case 'NEW_SEARCH':
            return __assign(__assign({}, DEFAULT_STATE), { term: action.term, options: action.options, location: action.location, fetching: true });
        default:
            return state;
    }
};
